import Repository from '@/repositories/marketing'
const mobileAppProfile = 'mobile_applications'

export default {
    showMobileAppDetails(mobileApplicationId){
        return Repository.get(`${mobileAppProfile}/${mobileApplicationId}.json`)
    },
    create(payload,config){
        return Repository.post(`${mobileAppProfile}.json`,payload,config)
    },
    update(mobileProfileId, payload, config) {
        return Repository.put(`${mobileAppProfile}/${mobileProfileId}.json`, payload, config)
    },
    // MobileApp API
    fetchmobileApp(config){
        return Repository.get(`mobile_applications.json`, config)
    },
    deleteMobileApp(id){
    return Repository.delete(`mobile_applications/${id}.json`)
    },

}